import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import './style.scss';
import IconButton from 'components/atoms/Button/IconButton';
import { disableAllMenu } from 'modules/actions/statusMenu';
import { sendQuality, setQuality, setResponse } from 'modules/actions/quality';
const Feedback = () => {
  const dispatch = useDispatch();

  const messageId = useSelector(state => state.quality.messageId);
  const options = useSelector(state => state.quality.options);
  // const responseMessage = useSelector(state => state.quality.response);

  const textRef = useRef();
  const [params, setParams] = useState({
    sel: '',
    text: '',
  });

  const closeModal = () => {
    dispatch(disableAllMenu());
  };

  const checkQuality = value => {
    setParams(prevState => {
      return {
        sel: value,
        text: prevState.text,
      };
    });
  };


  const confirmEvt = () => {
    if (params.sel === '' || params.text === '') return false;
    const payload = {
      message_id: messageId,
      in_type: 'quality',
      quality: {
        value: params.sel,
        // ...options[sel - 1],
        comment: textRef.current.value,
      },
    };

    console.log(payload)
    dispatch(sendQuality(payload));
  };

  const setParamsText = () => {
    setParams(prevState => {
      return {
        sel: prevState.sel,
        text: textRef.current.value,
      };
    });
  };

  return (
    <div className="feedback_bg">
      <div className="feedback_area">
        {/* <i className="ri-close-line" onClick={closeModal} /> */}
        <div className="fd_name">
          <div className="fd_name_02">
             <IconButton icon="mail-outline" styleDef={{ margin: '6px 3px 0 0', width: '22px', fontSize: '25px', height: '18px', color: '#0061AF' }} />
            <span>의견 남기기</span> 
          </div>
        </div>
      <button type="button" aria-label="닫기" title="사용자 의견 남기기 창 닫기" className="_close_btn_div" onClick={closeModal} >
          <i className="ri-close-line-2" />
        </button>
        <div className="fd_btn_text">답변이 어땠는지 평가해주세요.</div>
        <div>
          {options.map(i => {
            const className = params.sel === i.value ? '_quality_item _sel' : '_quality_item';
            return (
              <button type="button" key={i.value} className={className} onClick={() => checkQuality(i.value)}>
                {i.message}
              </button>
            );
          })}
        </div>
        <div className="fd_btn_text">답변 관련 의견을 남겨주세요.</div>
        <textarea
          ref={textRef}
          maxLength="300"
          className="feed_input_textarea"
          onChange={setParamsText}
          placeholder="의견을 남겨주세요."
        />
        <div style={{height:'16px'}}>
          <i className="ri-infomation-line" style={{ display: params.sel === '' || params.text === '' ? '' : 'none' }}/>
          <p className="comment" style={{ display: params.sel === '' || params.text === '' ? '' : 'none' }}>
            평가 및 의견 작성 필수
          </p>
        </div>
        <button type="button" title="사용자 의견 남기기 확인" className={`fd_send_btn ${params.sel === '' || params.text === '' ? '_inactive' : ''}`} onClick={confirmEvt}>
          확인
        </button>
      </div>
    </div>
  );
};

export default Feedback;
